<template>
  <div class="register-step">
    <div class="step-header">
      <h2>请上传身份证照片</h2>
    </div>
    
    <div class="id-card-upload">
      <div class="upload-item">
        <div class="upload-box" @click="$refs.frontInput.click()">
          <img v-if="idCardFront" :src="idCardFront" class="preview" />
          <div v-else class="upload-placeholder">
            <div class="placeholder-text">请上传身份证正面照片</div>
            <div class="placeholder-tag">人像面</div>
          </div>
        </div>
        <input type="file" ref="frontInput" @change="handleFileChange($event, 'front')" accept="image/*" style="display:none" />
      </div>
      
      <div class="upload-item">
        <div class="upload-box" @click="$refs.backInput.click()">
          <img v-if="idCardBack" :src="idCardBack" class="preview" />
          <div v-else class="upload-placeholder">
            <div class="placeholder-text">请上传身份证反面照片</div>
            <div class="placeholder-tag">国徽面</div>
          </div>
        </div>
        <input type="file" ref="backInput" @change="handleFileChange($event, 'back')" accept="image/*" style="display:none" />
      </div>
    </div>
    
    <div class="ocr-result" v-if="ocrName || ocrIdCard">
      <div class="ocr-tip">✓ 识别成功，请核对信息（可编辑）</div>
      <div class="form-group">
        <label>姓名</label>
        <input :value="ocrName" @input="$emit('update:ocrName', $event.target.value)" placeholder="请输入姓名" />
      </div>
      <div class="form-group">
        <label>身份证号</label>
        <input :value="ocrIdCard" @input="$emit('update:ocrIdCard', $event.target.value)" placeholder="请输入身份证号" maxlength="18" />
      </div>
    </div>
    
    <div class="btn-area">
      <button class="prev-btn" @click="$emit('prev')">
        <span class="btn-arrow">←</span>
        <span>上一步</span>
      </button>
      <button 
        class="submit-btn"
        :disabled="!canSubmit"
        @click="$emit('next')"
      >
        <span>下一步</span>
        <span class="btn-arrow">→</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IdCardStep',
  props: {
    idCardFront: { type: String, default: '' },
    idCardBack: { type: String, default: '' },
    ocrName: { type: String, default: '' },
    ocrIdCard: { type: String, default: '' }
  },
  computed: {
    canSubmit() {
      return this.idCardFront && this.idCardBack && this.ocrName && this.ocrIdCard
    }
  },
  methods: {
    handleFileChange(event, type) {
      const file = event.target.files[0]
      if (!file) return
      
      if (!file.type.startsWith('image/')) {
        this.$emit('error', '请选择图片文件')
        return
      }
      
      if (file.size > 5 * 1024 * 1024) {
        this.$emit('error', '图片大小不能超过5MB')
        return
      }
      
      const reader = new FileReader()
      reader.onload = (e) => {
        const base64 = e.target.result
        this.$emit('file-change', { type, base64 })
      }
      reader.onerror = () => {
        this.$emit('error', '图片读取失败')
      }
      reader.readAsDataURL(file)
    }
  }
}
</script>

<style scoped>
.register-step {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-radius: 24px;
  padding: 20px 16px;
  box-shadow: 
    0 20px 60px rgba(0, 0, 0, 0.15),
    0 0 0 1px rgba(255, 255, 255, 0.5) inset;
  animation: slideUp 0.5s ease-out;
  position: relative;
  overflow: hidden;
}


@keyframes slideUp {
  from { opacity: 0; transform: translateY(30px); }
  to { opacity: 1; transform: translateY(0); }
}

.step-header {
  text-align: center;
  margin-bottom: 16px;
}

.step-header h2 {
  font-size: 24px;
  color: #1a1a2e;
  margin: 0 0 8px;
  font-weight: 700;
}

.step-header .subtitle {
  font-size: 14px;
  color: #8e8e93;
  margin: 0;
}

.form-group {
  margin-bottom: 16px;
}

.form-group label {
  display: block;
  font-size: 14px;
  color: #1a1a2e;
  margin-bottom: 8px;
  font-weight: 600;
}

.form-group input {
  width: 100%;
  height: 48px;
  border: 2px solid #e8e8ed;
  border-radius: 12px;
  padding: 0 14px;
  font-size: 16px;
  box-sizing: border-box;
  -webkit-appearance: none;
  appearance: none;
  background: #fff;
  touch-action: manipulation;
  outline: none;
  transition: all 0.3s ease;
}

.form-group input:focus {
  border-color: #2B77FF;
  box-shadow: 0 0 0 4px rgba(43, 119, 255, 0.1);
}

.id-card-upload {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 16px;
}

.upload-item {
  width: 100%;
}

.upload-box {
  width: 100%;
  height: 160px;
  background: linear-gradient(135deg, #f0f0f5 0%, #e8e8ed 100%);
  border: 2px dashed #c0c0c5;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  overflow: hidden;
  -webkit-tap-highlight-color: rgba(43, 119, 255, 0.2);
  touch-action: manipulation;
  transition: all 0.3s ease;
}

.upload-box:active {
  border-color: #2B77FF;
  background: linear-gradient(135deg, #EBF3FF 0%, #fff 100%);
  transform: scale(0.98);
}

.upload-box .preview {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 14px;
}


.upload-placeholder {
  text-align: center;
}

.placeholder-text {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 10px;
}

.placeholder-tag {
  font-size: 14px;
  color: #2B77FF;
  font-weight: 600;
  padding: 6px 20px;
  border: 1px dashed #ccc;
  border-radius: 6px;
  background: #fff;
  display: inline-block;
}

.ocr-result {
  background: linear-gradient(135deg, #e8f5e9 0%, #f1f8e9 100%);
  border-radius: 16px;
  padding: 16px;
  margin-bottom: 20px;
  border: 1px solid rgba(103, 194, 58, 0.2);
}

.ocr-tip {
  color: #4caf50;
  font-size: 14px;
  margin-bottom: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
}

.btn-area {
  display: flex;
  gap: 12px;
  margin-top: 16px;
}

.submit-btn {
  flex: 1;
  height: 54px;
  background: linear-gradient(135deg, #2B77FF 0%, #1A5FD9 100%);
  color: #fff;
  border: none;
  border-radius: 27px;
  font-size: 17px;
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(43, 119, 255, 0.3);
  touch-action: manipulation;
  user-select: none;
  -webkit-user-select: none;
  transition: all 0.3s ease;
  font-weight: 600;
  min-height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  box-shadow: 0 8px 25px rgba(43, 119, 255, 0.35);
}

.submit-btn:active {
  transform: scale(0.97);
  box-shadow: 0 4px 15px rgba(43, 119, 255, 0.35);
}

.submit-btn:disabled {
  background: linear-gradient(135deg, #d0d0d0 0%, #b0b0b0 100%);
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
}

.prev-btn {
  min-width: 100px;
  height: 54px;
  background: rgba(255, 255, 255, 0.9);
  color: #666;
  border: 2px solid #e0e0e0;
  border-radius: 27px;
  font-size: 15px;
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0.1);
  touch-action: manipulation;
  user-select: none;
  -webkit-user-select: none;
  transition: all 0.3s ease;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font-weight: 500;
}

.prev-btn:active {
  background: #f5f5f5;
  transform: scale(0.97);
}

.btn-arrow {
  font-size: 16px;
  transition: transform 0.3s ease;
}

@media screen and (max-width: 480px) {
  .register-step {
    padding: 20px 16px;
    border-radius: 20px;
  }

  .header-icon {
    font-size: 40px;
  }

  .step-header h2 {
    font-size: 20px;
  }

  .upload-box {
    height: 95px;
  }

  .prev-btn {
    min-width: 90px;
  }
}

@media screen and (max-width: 360px) {
  .register-step {
    padding: 16px 12px;
  }

  .step-header h2 {
    font-size: 18px;
  }

  .btn-area {
    gap: 8px;
  }
  
  .prev-btn {
    min-width: 80px;
  }
}
</style>
